import "../styles/about.css";
import { FaEdit, FaUserCircle } from "react-icons/fa";
import sun from "../images/carrot.png";
import { useState, useEffect } from "react";
import api from "./api";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const About = () => {
    const [profile, setProfile] = useState(null);
    const [username, setUsername] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
     const [firstNameEn, setFirstNameEn] = useState("");
    const [lastNameEn, setLastNameEn] = useState("");
    const [birthDate, setBirthDate] = useState("");
    const [age, setAge] = useState("");
    const [province, setProvince] = useState("");
    const [city, setCity] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [profileImage, setProfileImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    // State های جدید برای لیست استان و شهر
    const [provincesList, setProvincesList] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [selectedProvinceId, setSelectedProvinceId] = useState("");
    const [selectedCityId, setSelectedCityId] = useState("");

    // پسورد
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    useEffect(() => {
        fetchProfile();
        fetchProvinces();
    }, []);

    // دریافت لیست استان‌ها
    const fetchProvinces = async () => {
        try {
            const response = await api.get("pre_student/api/v3/locations/provinces/");
            setProvincesList(response.data);
        } catch (error) {
            console.error("خطا در دریافت لیست استان‌ها:", error);
        }
    };

    // دریافت لیست شهرها بر اساس استان انتخاب شده
    const fetchCities = async (provinceId) => {
        if (!provinceId) {
            setCitiesList([]);
            return;
        }
        try {
            const response = await api.get(`pre_student/api/v3/locations/cities/${provinceId}/`);
            setCitiesList(response.data);
        } catch (error) {
            console.error("خطا در دریافت لیست شهرها:", error);
            setCitiesList([]);
        }
    };

    // بعد از بارگذاری پروفایل، اگر استان انتخاب شده داشت، شهرهای آن را دریافت کن
    useEffect(() => {
        if (profile && profile.province) {
            fetchCities(profile.province);
        }
    }, [profile]);

    const fetchProfile = () => {
        api.get("pre_student/api/v3/pre-student/profile/")
            .then((res) => {
                setProfile(res.data);
                setUsername(res.data.username || "");
                setFirstName(res.data.first_name || "");
                setLastName(res.data.last_name || "");
                setBirthDate(res.data.birth_date || "");
                setAge(res.data.age || "");
                setProvince(res.data.province || "");
                setCity(res.data.city || "");
                setPhoneNumber(res.data.phone_number || "");
                setSelectedProvinceId(res.data.province || "");
                setSelectedCityId(res.data.city || "");
                setFirstNameEn(res.data.first_name_en || "");
                setLastNameEn(res.data.last_name_en || "");
            })
            .catch((err) => {
                console.error("خطا در گرفتن اطلاعات پروفایل:", err);
            });
    };

    // انتخاب فایل و پیش‌نمایش
    const handleFileSelect = (file) => {
        if (!file) return;
        if (file.size > 2 * 1024 * 1024) {
            alert("حجم تصویر نباید بیشتر از ۲ مگابایت باشد");
            return;
        }
        setProfileImage(file);
        setPreviewImage(URL.createObjectURL(file));
    };

   
    const handleSavePersonalInfo = async () => {
    const dataToUpdate = {};
    
    if (firstName !== profile.first_name) dataToUpdate.first_name = firstName;
    if (lastName !== profile.last_name) dataToUpdate.last_name = lastName;
    
    // اضافه کردن فیلدهای انگلیسی
    if (firstNameEn !== profile.first_name_en) dataToUpdate.first_name_en = firstNameEn;
    if (lastNameEn !== profile.last_name_en) dataToUpdate.last_name_en = lastNameEn;

    try {
        // 1. ابتدا اطلاعات متنی را به‌روزرسانی کنید
        if (Object.keys(dataToUpdate).length > 0) {
            await api.patch("pre_student/api/v3/pre-student/profile/update/", dataToUpdate);
        }

        // 2. اگر تصویری انتخاب شده، آن را آپلود کنید
        if (profileImage) {
            const formData = new FormData();
            formData.append("profile_image", profileImage);
            await api.patch("pre_student/api/v3/pre-student/profile/update/", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            
            setProfileImage(null);
        }
        
        alert("اطلاعات شخصی با موفقیت بروزرسانی شد");
        fetchProfile(); 
    } catch (err) {
        console.error("Error saving personal info:", err);
        alert("خطا در بروزرسانی اطلاعات شخصی");
    }
};

    const handleUpdateProfile = () => {
        const data = {};

        if (birthDate !== profile.birth_date) data.birth_date = birthDate;
        if (age !== profile.age) data.age = parseInt(age);
        if (province !== profile.province) data.province = parseInt(province);
        if (city !== profile.city) data.city = parseInt(city);

        if (Object.keys(data).length === 0) {
            alert("تغییری در اطلاعات تکمیلی ایجاد نشده است.");
            return;
        }

        api.patch("pre_student/api/v3/pre-student/profile/update/", data)
            .then(() => {
                alert("اطلاعات تکمیلی با موفقیت بروزرسانی شد");
                fetchProfile();
            })
            .catch((err) => {
                console.error(err);
                alert("خطا در بروزرسانی اطلاعات تکمیلی");
            });
    };

    // تغییر پسورد
    const handleChangePassword = () => {
        if (!password || !confirmPassword) {
            alert("لطفا تمام فیلدهای رمز عبور را پر کنید");
            return;
        }

        if (password !== confirmPassword) {
            alert("رمز عبور و تکرار آن مطابقت ندارند.");
            return;
        }

        if (password.length < 6) {
            alert("رمز عبور باید حداقل ۶ کاراکتر باشد");
            return;
        }

        api.post("pre_student/api/v3/pre-student/change-password/", {
            password: password,
            confirm_password: confirmPassword,
        })
            .then((res) => {
                alert(res.data.message || "رمز عبور با موفقیت تغییر کرد");
                setPassword("");
                setConfirmPassword("");
            })
            .catch((err) => {
                if (err.response?.data?.error) {
                    alert(err.response.data.error);
                } else {
                    alert("خطا در تغییر رمز عبور");
                }
            });
    };

    if (!profile) return <div className="text-center mt-5">در حال بارگذاری...</div>;

    return (
        <div className="me-lg-5 mb-2 pe-lg-5">
            <div className="row p-0">
                {/* باکس اول - اطلاعات شخصی (نام، نام خانوادگی، عکس) */}
                <div className="col-lg-4 d-flex d-lg-block justify-content-center col-12 p-0">
                    <div>
                        <div className="my-3">
                            <span className="fw-bold mx-3"> اطلاعات شخصی</span>
                            <img src={sun} width={33} height={33} alt="icon" />
                        </div>
                        <div className="student-box p-5" style={{ width: "350px" }}>
                         
                            {/* فرم اطلاعات شخصی */}
                            <div style={{ marginTop: "20px" }}>
                                <div>
                                    <label>نام</label>
                                    <input
                                        className="about-input d-block"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label> نام خانوادگی</label>
                                    <input
                                        className="about-input d-block"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                </div>
                            </div>
                              <div >
                                <div>
                                    <label> نام (انگلیسی) </label>
                                    <input
                                        className="about-input d-block"
                                        value={firstNameEn}
                                        onChange={(e) => setFirstNameEn(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label>   نام خانوادگی (انگلیسی)</label>
                                    <input
                                        className="about-input d-block"
                                        value={lastNameEn}
                                        onChange={(e) => setLastNameEn(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label> تلفن همراه </label>
                                    <div className="d-block about-input">
                                        {phoneNumber}
                                    </div>
                                </div>
                            </div>
                            
                            {/* دکمه تایید واحد برای ذخیره نام، نام خانوادگی و عکس */}
                            <div className="d-flex justify-content-center">
                                <button
                                    className="upload-btn py-2 mt-3 px-5"
                                    onClick={handleSavePersonalInfo}
                                >
                                    ذخیره اطلاعات شخصی
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 d-flex d-lg-block justify-content-center col-12 p-0">
                    <div>
                        <div>
                            <div className="my-3">
                                <span className="fw-bold mx-3"> اطلاعات تکمیلی</span>
                                <img src={sun} width={33} height={33} alt="icon" />
                            </div>
                        </div>

                        <div className="student-box p-5" style={{ width: "350px" }}>
                            <div className="edit-icon">
                                <FaEdit style={{ fontSize: "20px" }} />
                            </div>
                            <div style={{ marginTop: "110px" }}>
                                <div>
                                    <label>تاریخ تولد</label>
                                    <DatePicker
                                        calendar={persian}
                                        locale={persian_fa}
                                        className="d-block about-input"
                                        value={birthDate}
                                        onChange={(date) => setBirthDate(date?.format("YYYY-MM-DD"))}
                                        style={{
                                            width: "100%",
                                            padding: "20px 30px" ,
                                            borderRadius: "8px",
                                            border: "1px solid #ccc",
                                            marginTop: "10px"
                                        }}
                                    />
                                </div>
                            </div>
                            
                            <div>
                                <div>
                                    <label>سن</label>
                                    <input
                                        type="number"
                                        className="about-input d-block"
                                        value={age}
                                        onChange={(e) => setAge(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label>استان</label>
                                    <select
                                        className="about-input d-block"
                                        value={selectedProvinceId}
                                        onChange={(e) => {
                                            const provinceId = e.target.value;
                                            setSelectedProvinceId(provinceId);
                                            setProvince(provinceId);
                                            setSelectedCityId("");
                                            setCity("");
                                            fetchCities(provinceId);
                                        }}
                                    >
                                        <option value="">انتخاب استان</option>
                                        {provincesList.map((province) => (
                                            <option key={province.id} value={province.id}>
                                                {province.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label>شهر</label>
                                    <select
                                        className="about-input d-block"
                                        value={selectedCityId}
                                        onChange={(e) => {
                                            const cityId = e.target.value;
                                            setSelectedCityId(cityId);
                                            setCity(cityId);
                                        }}
                                        disabled={!selectedProvinceId}
                                    >
                                        <option value="">انتخاب شهر</option>
                                        {citiesList.map((city) => (
                                            <option key={city.id} value={city.id}>
                                                {city.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="d-flex justify-content-center">
                                <button
                                    className="upload-btn py-2 mt-3 px-5"
                                    onClick={handleUpdateProfile}
                                >
                                    ذخیره اطلاعات تکمیلی
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* باکس سوم - تغییر پسورد */}
                <div className="col-lg-4 d-flex d-lg-block justify-content-center col-12 p-0">
                    <div>
                        <div className="col-12 col-lg-4">
                            <div className="my-3">
                                <span className="fw-bold mx-3"> کلمه عبور</span>
                                <img src={sun} width={33} height={33} alt="icon" />
                            </div>
                        </div>
                        <div className="student-box p-5" style={{ width: "350px" }}>
                            <div className="edit-icon">
                                <FaEdit style={{ fontSize: "20px" }} />
                            </div>
                            <div style={{ marginTop: "100px" }}>
                                <div>
                                    <label>کلمه عبور جدید</label>
                                    <input
                                        type="password"
                                        className="about-input d-block"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="رمز عبور جدید را وارد کنید"
                                    />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label>تکرار کلمه عبور جدید</label>
                                    <input
                                        type="password"
                                        className="about-input d-block"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        placeholder="رمز عبور جدید را تکرار کنید"
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-center">
                                <button
                                    className="upload-btn py-2 mt-3 px-5"
                                    onClick={handleChangePassword}
                                >
                                    تغییر رمز عبور
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;